/**
 * Organization Filters Component
 */

import React from "react";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select, { type SelectOption } from "../../../components/ui/Select";

interface OrganizationFiltersProps {
	statusFilter?: string;
	searchQuery: string;
	onStatusChange: (status: string | undefined) => void;
	onSearchChange: (query: string) => void;
	onClearFilters: () => void;
}

const STATUS_OPTIONS: SelectOption[] = [
	{ value: "", label: "All Statuses" },
	{ value: "active", label: "Active" },
	{ value: "inactive", label: "Inactive" },
	{ value: "suspended", label: "Suspended" },
];

const OrganizationFilters: React.FC<OrganizationFiltersProps> = ({
	statusFilter,
	searchQuery,
	onStatusChange,
	onSearchChange,
	onClearFilters,
}) => {
	return (
		<div className="bg-card border border-border rounded-lg p-4">
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
				{/* Search */}
				<div className="md:col-span-2">
					<Input
						type="text"
						placeholder="Search by name, email, or DOF ID..."
						value={searchQuery}
						onChange={(e) => onSearchChange(e.target.value)}
					/>
				</div>

				{/* Status Filter */}
				<Select
					label="Status"
					options={STATUS_OPTIONS}
					value={statusFilter || ""}
					onValueChange={(value) =>
						onStatusChange(value === "" ? undefined : String(value))
					}
				/>

				{/* Clear Filters */}
				{(statusFilter || searchQuery) && (
					<div className="flex items-end">
						<Button
							variant="outline"
							size="sm"
							onClick={onClearFilters}
							iconName="X"
							iconPosition="left"
						>
							Clear Filters
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};

export default OrganizationFilters;
